const SESSION_KEY = "ga_service_session";

export interface GAServiceSession {
  gaId: string;
  gaName: string;
  brokerAccountId: string;
  brokerAgencyName: string;
  scope: "view_only" | "assist";
  enteredAt: string;
}

export function getGAServiceSession(): GAServiceSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as GAServiceSession) : null;
  } catch {
    return null;
  }
}

export function startGAServiceSession(session: Omit<GAServiceSession, "enteredAt">): void {
  const full: GAServiceSession = { ...session, enteredAt: new Date().toISOString() };
  localStorage.setItem(SESSION_KEY, JSON.stringify(full));
}

export function endGAServiceSession(): void {
  localStorage.removeItem(SESSION_KEY);
}

export function enterBrokerPortal(
  session: Omit<GAServiceSession, "enteredAt">,
  brokerAgencyId: string
): void {
  startGAServiceSession(session);
  // Navigate to broker portal — the role switch + page reload resets the dev-bypass session
  window.location.href = `/?role=broker&ga_service_for=${encodeURIComponent(brokerAgencyId)}`;
}

export function returnToGAPortal(): void {
  endGAServiceSession();
  window.location.href = "/?role=ga";
}
